export enum ContentFieldsEnum {
  FieldsCode = 'fields.code',
  FlightNotChangeableGeneral = 'FlightNotChangeableGeneral',
  Generic = 'GENERIC'
}

export type ContentFieldsEnumType = keyof typeof ContentFieldsEnum;
